// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"1ee377ff","513":"6ea10dfb","703":"b9089d34","787":"c522baa1"}[chunkId] + ".chunk.js";
};